import http from "../../../../../../core/utils/apis/skillApi";
import { AppAuthContext } from "../../../../../../core/contexts/AppAuthProvider";

const SkillMatrixByUserService = {
  searchUsersByName: (query, department) =>
    http.get("/manager-skill-report/search-users", {
      params: { query, department },
    }),

  getSkillsByUser: (userId, department) =>
    http.get(`/manager-skill-report/${userId}/skills`, {
      params: { department },
    }),

  updateUserSkills: (userId, skillsToUpdate) =>
    http.patch(`/skills-reports/${userId}/update-skills`, skillsToUpdate), 
};

export default SkillMatrixByUserService;
